export const iconFontAwesomePunctuationSymbolsExclamation = (
	<i className="fa-solid fa-exclamation"></i>
);
